import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import logo from "../assets/logo.svg";
import logoutIcon from "../assets/logoutIcon.svg";
import menuIcon from "../assets/menuIcon.svg";
import appIcon from "../assets/appIcon.svg";
import blackAppIcon from "../assets/blackAppIcon.svg";
import notIcon from "../assets/notIcon.svg";
import blackNotIcon from "../assets/blackNotIcon.svg";
import jobIcon from "../assets/jobIcon.svg";
import blackJobIcon from "../assets/blackJobIcon.svg";
import intIcon from "../assets/intIcon.svg";
import blackIntIcon from "../assets/blackIntIcon.svg";
import createJobIcon from "../assets/createJobIcon.svg";
import blackCreateJobIcon from "../assets/blackCreateJobIcon.svg";
import profileIcon from "../assets/profileIcon.svg";
import blackProfileIcon from "../assets/blackProfileIcon.svg";
import fullLogo from "../assets/fullLogo.svg";
import LogOutModal from "./LogOutModal";
import infoIcon from "../assets/infoIcon.svg";

const UnverifiedCompany = () => {
  const userRole = localStorage.getItem("userRole"); // Get user role
  const [sidebarOpen, setSidebarOpen] = useState(false); // Sidebar state
  const [showLogOutModal, setShowLogOutModal] = useState(false); // Sidebar state
  const sidebarRef = useRef(null); // Ref for sidebar

  // Define dropdown data for both roles
  const dropdownData = [
    {
      activeLogo: blackJobIcon,
      inactiveLogo: jobIcon,
      title: "Jobs",
      linkTo: "/dashboard/jobs",
      roles: ["student", "organization"], // Accessible to both roles
    },
    {
      activeLogo: blackCreateJobIcon,
      inactiveLogo: createJobIcon,
      title: "Create Job",
      linkTo: "/dashboard/create-job",
      roles: ["organization"], // Accessible to organization only
    },
    {
      activeLogo: blackAppIcon,
      inactiveLogo: appIcon,
      title: "Applications",
      linkTo: "/dashboard/applications",
      roles: ["student", "organization"], // Accessible to students only
    },
    {
      activeLogo: blackIntIcon,
      inactiveLogo: intIcon,
      title: "Interviews",
      linkTo: "/dashboard/interviews",
      roles: ["organization"], // Accessible to both roles
    },
    {
      activeLogo: blackNotIcon,
      inactiveLogo: notIcon,
      title: "Notifications",
      linkTo: "/dashboard/notifications",
      roles: ["student", "organization"], // Accessible to both roles
    },
    {
      activeLogo: blackProfileIcon,
      inactiveLogo: profileIcon,
      title: "Profile",
      linkTo: "/dashboard/profile",
      roles: ["student", "organization"], // Accessible to both roles
    },
  ];

  // Filter dropdown items based on user role
  const filteredDropdownData = dropdownData.filter((item) =>
    item.roles.includes(userRole)
  );

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen); // Toggle sidebar state
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false); // Close sidebar when clicking outside
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <section className="w-100">
      {/* Sidebar */}
      <section
        className={`flex w-[280px] overflow-auto bg-white border-r text-left text-[16px] font-medium leading-[24px] justify-between h-full flex-col min-h-screen side-shadow z-50 fixed transition-all ease-in-out duration-700 ${
          sidebarOpen ? "left-0" : "xsm:-left-[280px]"
        }`}
        ref={sidebarRef}
        id="side-bar"
      >
        <div className="w-100 flex flex-col self-center gap-2 h-full">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center my-2x gap-2 px-4 justify-center"
          >
            <img src={fullLogo} className="w-" alt="Logo" />
          </Link>

          {/* Dropdown Menu */}
          <div className="flex flex-col w-100 h-full justify-around gap-3 px-4">
            <section className="flex flex-col gap-3">
              <ul className="list mt-2 w-full flex gap-3 flex-col items-center py-2 transition-all ease-in-out duration-500">
                {filteredDropdownData.map((dropdown) => (
                  <div
                    key={dropdown.title}
                    className="flex w-full gap-3 py-2 px-3 rounded-[8px] text-[#667085] cursor-not-allowed opacity-60"
                  >
                    <img
                      src={dropdown.inactiveLogo}
                      alt={`${dropdown.title} icon`}
                    />
                    <span>{dropdown.title}</span>
                  </div>
                ))}
              </ul>
            </section>
            {/* Logout */}
            <div
              className="flex gap-3 items-center justify-center bg-[#BC1518] py-3 px-2 rounded-[8px] text-white cursor-pointer"
              onClick={() => setShowLogOutModal(!showLogOutModal)} // Attach the click handler
            >
              <img src={logoutIcon} alt="Logout Icon" />
              <span>Logout</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="flex flex-col md:ms-[280px] h-screen mainScreen relative">
        {/* Modal Section */}

        <div className="min-h-screen h-full xsm:fixed flex w-full items-center justify-center absolute rejection-card flex-col">
          <div className="flex flex-col gap-3 bg-white w-[80%] rounded-2xl items-center justify-center py-9 ">
            <img src={infoIcon} alt="infoIcon" />
            <span className="text-xl font-bold">
              Your account is almost ready!
            </span>
            <span className=" text-[#475467] md:max-w-[450px] text-center">
              Your account is awaiting approval. Please check back in a few
              minutes to access your dashboard.
            </span>
            <div
              className="flex gap-3 items-center justify-center bg-[#BC1518] px-[40px] py-2  rounded-[8px] text-white cursor-pointer"
              onClick={() => setShowLogOutModal(!showLogOutModal)} // Attach the click handler
            >
              <img src={logoutIcon} alt="Logout Icon" />
              <span>Logout</span>
            </div>{" "}
          </div>
        </div>
        <div className="flex md:hidden w-100 py-3 items-center justify-between top-bar px-9 xsm:px-6">
          <img
            src={logo}
            onClick={toggleSidebar}
            alt="Menu Icon"
            className="cursor-pointer text-3xl text-blue-700"
          />
          <img
            className="z-50 cursor-pointer"
            src={menuIcon}
            onClick={toggleSidebar}
            alt="menuIcon"
          />
        </div>
        {showLogOutModal && (
          <LogOutModal setShowLogOutModal={setShowLogOutModal} />
        )}

        <Outlet />
      </section>
    </section>
  );
};

export default UnverifiedCompany;
